import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeaderLayout from '../layout/header_main';
import HeaderwithoutLogo from '../layout/header_without_logo';
import { Navigate } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import RegisterScreen from '../pages/registerPage';
import NewRegisterScreen from '../pages/new_register_page';
import ErrorScreen from '../pages/errorPage';
import VerifyScreen from '../pages/verifyPage';
import VerifiedScreen from '../pages/alreadyRegistered';
import LoginScreen from '../pages/loginPage';

import LoadingModal from '../widget/w-loading';

interface navBarProps {}
const RoutePage: React.FC<navBarProps> = () => {
  useEffect(() => {}, []);

  const loading = useSelector((state: any) => state.loading.value.loading);
  const ExternalRedirect = ({ url }: { url: string }) => {
    useEffect(() => {
      window.location.replace(url);
    }, [url]);

    return null;
  };

  return (
    <div>
      {<LoadingModal />}
      <Router>
        <Routes>
          <Route element={<HeaderwithoutLogo />}>
            <Route path='/login' element={<LoginScreen />} />
          </Route>

          <Route element={<HeaderLayout />}>
            <Route path='/error' element={<ErrorScreen />} />
            <Route path='/registration-success' element={<VerifiedScreen />} />
            <Route path='/invalid_token' element={<ErrorScreen />} />
            <Route path='/verify' element={<VerifyScreen />} />
            <Route path='/verified' element={<VerifiedScreen />} />
            <Route path='/register' element={<RegisterScreen />} />
            <Route path='/signup' element={<NewRegisterScreen />} />
          </Route>
          {/* External Redirect */}
          <Route
            path='/'
            element={<ExternalRedirect url='https://www.arivonix.ai' />}
          />
        </Routes>
      </Router>
    </div>
  );
};

export default RoutePage;
